import React, { useEffect, useState, useRef, lazy } from 'react';
/* ─── TESTIMONIALS ─── */
const testimonialImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/9yfp1rV4PD1mKwhrDuCaBk/FLORENCIA.png',
  alt: 'Reseña de Florencia — primera semana, Mateo comió zucchini'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/eVWkH5ppVXuEvG5oSvV7aS/CARLA.png',
  alt: 'Reseña de Carla — el bono Anti-Detectives fue lo que más usó'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hz6TjNRDnz6z3B9n5UGiA5/VALENTINA.png',
  alt: 'Reseña de Valentina — en 4 días cambió todo con recetas crujientes'
}];
export function TestimonialsSection() {
  const [activeSlide, setActiveSlide] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;
    const handleScroll = () => {
      const children = container.children;
      if (!children.length) return;
      const containerRect = container.getBoundingClientRect();
      const containerCenter = containerRect.left + containerRect.width / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;
      for (let i = 0; i < children.length; i++) {
        const child = children[i] as HTMLElement;
        const childRect = child.getBoundingClientRect();
        const childCenter = childRect.left + childRect.width / 2;
        const distance = Math.abs(containerCenter - childCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      }
      setActiveSlide(closestIndex);
    };
    container.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSlide = (index: number) => {
    const container = scrollRef.current;
    if (!container) return;
    const child = container.children[index] as HTMLElement;
    if (!child) return;
    const containerRect = container.getBoundingClientRect();
    const childRect = child.getBoundingClientRect();
    const scrollLeft = container.scrollLeft + childRect.left - containerRect.left - (containerRect.width - childRect.width) / 2;
    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#FDF9F3] py-10 px-5 sm:py-14 sm:px-6" data-id="element-309">
      <div className="max-w-[680px] mx-auto" data-id="element-310">
        <h2 className="text-[#2C3E50] text-[24px] sm:text-[28px] font-black text-center mb-6 tracking-tight" data-id="element-311">
          Lo que dicen las mamás
        </h2>

        {/* Horizontal swipeable gallery */}
        <div className="relative" data-id="element-312">
          <style data-id="element-313">{`
            .testimonials-scroll::-webkit-scrollbar { display: none; }
          `}</style>
          <div ref={scrollRef} className="flex overflow-x-scroll gap-4 pb-4 snap-x snap-mandatory -mx-5 px-5 testimonials-scroll" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch',
          overscrollBehaviorX: 'contain',
          touchAction: 'pan-y'
        }} data-id="element-314">
            {testimonialImages.map((img, i) => <div key={i} className="w-[85vw] max-w-[340px] flex-shrink-0 snap-center" data-id="element-315">
                <img src={img.src} alt={img.alt} className="w-full rounded-2xl shadow-[0_8px_24px_rgba(0,0,0,0.08)] select-none pointer-events-none border border-gray-100" loading="lazy" decoding="async" draggable={false} data-id="element-316" />
              </div>)}
          </div>

          {/* Dot indicators */}
          <div className="flex justify-center gap-2 mt-3" data-id="element-317">
            {testimonialImages.map((_, i) => <button key={i} onClick={() => scrollToSlide(i)} className={`rounded-full transition-all duration-300 ${activeSlide === i ? 'w-6 h-2.5 bg-[#5E8D5A]' : 'w-2.5 h-2.5 bg-gray-300'}`} aria-label={`Ir a reseña ${i + 1}`} data-id="element-318" />)}
          </div>
        </div>
      </div>
    </section>;
}
/* ─── PRODUCT SECTION (Removed) ─── */
export function ProductSection() {
  return null;
}
/* ─── BONUS SECTION (Removed) ─── */
export function BonusSection() {
  return null;
}
/* ─── VALUE STACK (Ultra Compact) ─── */
export function ValueStackSection() {
  return <section style={{
    background: 'linear-gradient(145deg, #2C3E50 0%, #1a252f 100%)'
  }} className="py-10 px-5 sm:py-12 sm:px-6" data-id="element-319">
      <div className="max-w-[500px] mx-auto" data-id="element-320">
        <h2 className="text-white text-[26px] sm:text-[30px] font-black text-center mb-8 tracking-tight" data-id="element-321">
          Todo lo que recibís hoy
        </h2>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-5 sm:p-6 mb-8 backdrop-blur-sm" data-id="element-322">
          <ul className="flex flex-col gap-4" data-id="element-323">
            <li className="flex items-start gap-3" data-id="element-324">
              <span className="text-[#5E8D5A] text-lg flex-shrink-0 mt-0.5" data-id="element-325">
                ✅
              </span>
              <div className="flex-1" data-id="element-326">
                <p className="text-white font-bold text-[15px] leading-tight mb-0.5" data-id="element-327">
                  Guía Maestra Método 3C
                </p>
                <p className="text-white/40 text-[13px] line-through font-medium" data-id="element-328">
                  $18.000
                </p>
              </div>
            </li>
            <li className="flex items-start gap-3" data-id="element-329">
              <span className="text-[#5E8D5A] text-lg flex-shrink-0 mt-0.5" data-id="element-330">
                ✅
              </span>
              <div className="flex-1" data-id="element-331">
                <p className="text-white font-bold text-[15px] leading-tight mb-0.5" data-id="element-332">
                  Bono 1: Semana Resuelta 7D
                </p>
                <p className="text-white/40 text-[13px] line-through font-medium" data-id="element-333">
                  $3.500
                </p>
              </div>
            </li>
            <li className="flex items-start gap-3" data-id="element-334">
              <span className="text-[#5E8D5A] text-lg flex-shrink-0 mt-0.5" data-id="element-335">
                ✅
              </span>
              <div className="flex-1" data-id="element-336">
                <p className="text-white font-bold text-[15px] leading-tight mb-0.5" data-id="element-337">
                  Bono 2: Guía Anti-Detectives
                </p>
                <p className="text-white/40 text-[13px] line-through font-medium" data-id="element-338">
                  $2.800
                </p>
              </div>
            </li>
            <li className="flex items-start gap-3" data-id="element-339">
              <span className="text-[#5E8D5A] text-lg flex-shrink-0 mt-0.5" data-id="element-340">
                ✅
              </span>
              <div className="flex-1" data-id="element-341">
                <p className="text-white font-bold text-[15px] leading-tight mb-0.5" data-id="element-342">
                  Bono 3: Pack Lunchbox Jardín
                </p>
                <p className="text-white/40 text-[13px] line-through font-medium" data-id="element-343">
                  $2.500
                </p>
              </div>
            </li>
            <li className="flex items-start gap-3" data-id="element-344">
              <span className="text-[#5E8D5A] text-lg flex-shrink-0 mt-0.5" data-id="element-345">
                ✅
              </span>
              <div className="flex-1" data-id="element-346">
                <p className="text-white font-bold text-[15px] leading-tight mb-0.5" data-id="element-347">
                  Bono 4: Planner Organizador 10/20/30
                </p>
                <p className="text-white/40 text-[13px] line-through font-medium" data-id="element-348">
                  $2.200
                </p>
              </div>
            </li>
            <li className="flex items-start gap-3" data-id="element-349">
              <span className="text-[#5E8D5A] text-lg flex-shrink-0 mt-0.5" data-id="element-350">
                ✅
              </span>
              <div className="flex-1" data-id="element-351">
                <p className="text-white font-bold text-[15px] leading-tight mb-0.5" data-id="element-352">
                  Bono 5: Guía Plato Seguro
                </p>
                <p className="text-white/40 text-[13px] line-through font-medium" data-id="element-353">
                  $1.800
                </p>
              </div>
            </li>
          </ul>

          <div className="mt-6 pt-6 border-t border-white/10 text-center" data-id="element-354">
            <img src="https://cdn.magicpatterns.com/uploads/1gJS9qn8hGidHjVXRN92gJ/Principal_y_Bonus.png" alt="Kit Método 3C — Guía principal + 5 bonos" className="w-full max-w-[400px] mx-auto mb-5 rounded-xl" loading="lazy" decoding="async" data-id="element-355" />
            <p className="text-white/50 text-[14px] font-bold uppercase tracking-wider mb-1" data-id="element-356">
              VALOR TOTAL: <span className="line-through" data-id="element-357">$30.800</span>
            </p>
            <p className="text-[#F5C842] text-[42px] sm:text-[48px] font-black leading-none mb-3" data-id="element-358">
              $12.999
            </p>
            <div className="bg-[#5E8D5A]/20 text-[#5E8D5A] border border-[#5E8D5A]/30 text-[13px] font-black py-1.5 px-4 rounded-full inline-block" data-id="element-359">
              💚 Ahorrás $17.801 — 58% OFF
            </div>
          </div>
        </div>

        <a href="#order" className="bg-[#E67E22] text-white text-[18px] font-black py-4 px-8 rounded-2xl block w-full text-center transition-all duration-200 hover:bg-[#d67118] hover:-translate-y-0.5" style={{
        boxShadow: '0 12px 32px rgba(230,126,34,0.3)'
      }} data-id="element-360">
          SÍ, QUIERO PAZ EN MI MESA →
        </a>
      </div>
    </section>;
}